export const AI_EMAIL_PLACEHOLDER_FORMAT = 'ai-email-placeholder';
export const AI_EMAIL_LINK_FORMAT = 'ai-email-link';
export const AI_EMAIL_SENDER_FORMAT = 'ai-email-sender';
export const AI_EMAIL_SOFT_BREAK_FORMAT = 'ai-email-soft-break';

export const AI_EMAIL_PLACEHOLDER_CLASS = 'ai-email-pill--placeholder';
export const AI_EMAIL_LINK_CLASS = 'ai-email-pill--link';
export const AI_EMAIL_SENDER_CLASS = 'ai-email-pill--sender';
export const AI_EMAIL_SOFT_BREAK_CLASS = 'ai-email-soft-break';

export const AI_EMAIL_PILL_TEXT_MAX_LENGTH = 100;
export const AI_EMAIL_SUBJECT_MAX_LENGTH = 190;
